import styled from 'styled-components'
import {COLOR} from 'src/service/constant/color'
import {customMedia} from "src/styles/common/common";


const InputFormWrap = styled.div`
  display: block;
`
const InputTelNumWrap = styled.div<{bgColor?: string}>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  margin-bottom: 24px;

  ${customMedia.lessThan('tablet')`
     height: 40px;
  `}
  > button {
    width: 200px;
    background: ${(props) => props.bgColor ? props.bgColor : COLOR.point1};
    border-radius: 0 10px 10px 0;
    border: none;
    padding: 0;
    font-size: 18px;
    font-family: NotoSansBold, sans-serif;
    color: ${COLOR.white};

    pointer-events: ${(props) => props.bgColor === COLOR.gray30 && "none"};

    ${customMedia.lessThan('tablet')`
     font-size: 14px;
     height: 40px;
  `}
    ${customMedia.lessThan('tablet_cut_line')`
    width: 109px;
     min-width: 109px;
     height: 40px;
  `}
  }

  &:before {
    content: "010";
    position: absolute;
    margin: 0 5px 0 20px;
    font-family: NotoSansMedium, sans-serif;
    line-height: 56px;
    font-size: 18px;
    ${customMedia.lessThan('tablet')`
     line-height: 40px;
     margin: 0 0 0 16px;
     font-size: 14px;
  `}
    ${customMedia.lessThan('mobile')`
     display: none;
  `}
  }

`
const InputCertWrap = styled.div`
  display: flex;
  position: relative; 
  margin-bottom: 24px;

  > div {
    position: relative;
    width: 100%;

  > span {
    display: inline-block;
    margin: 0 0 0 -67px;
    height: 56px;
    line-height: 56px;
    font-size: 18px;
    font-family: NotoSansMedium, sans-serif;
    ${customMedia.lessThan('tablet')`
      font-size: 14px;
      line-height: 40px;
      height: 40px;
      margin: 0 0 0 -55px;
  `}
  }
    }

  .validate_check_msg {
    position: absolute;
    top: 100%;
    left: 0;
    color: red;
    font-size: 14px;
    margin-top: 4px;
    margin-left: 15px;
    
    font-family: NotoSansRegular, sans-serif;
  }
`

const InputDefatultWrap = styled.div`
  display: flex;
  position: relative; 
  margin-bottom: 24px;

  > div {
    position: relative;
    width: 100%;

    > img {
      position: absolute;
      top: 50%;
      right: 18px;
      transform: translateY(-50%);
      width: 16px;
      height: 11px;

      ${customMedia.lessThan("tablet")`
        right: 10px
        top: 50%;
      `}
    }
  }

  .validate_check_msg {
    position: absolute;
    top: 100%;
    left: 0;
    color: red;
    font-size: 14px;
    margin-top: 4px;
    margin-left: 15px;
    
    font-family: NotoSansRegular, sans-serif;
  }
`;

const InputTelNum = styled.input`
  display: flex;
  line-height: 56px;
  max-width: 400px;
  width: 100%;
  border: 1px solid #CED6E3;
  border-radius: 10px 0 0 10px;
  text-indent: 55px;
  font-family: NotoSansMedium, sans-serif;
  font-size: 18px;

  ::placeholder {
    color: ${COLOR.blueGray3};
    font-family: NotoSansRegular, sans-serif;
  }

  ${customMedia.lessThan('tablet')`
     height: 40px;
     font-size: 14px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
     width :100%;
     line-height: 40px;
  `}
  ${customMedia.lessThan('mobile')`
     text-indent: 16px; 
  `}
`
const InputCert = styled.input`
  border-radius: 10px;
  width: 100%;
  height: 56px;
  border: 1px solid ${COLOR.blueGray2};
  text-indent: 20px;
  font-size: 18px;

  &::placeholder {
    font-family: NotoSansRegular, sans-serif;
    color: ${COLOR.blueGray3};
  }

  ${customMedia.lessThan('tablet')`
     height: 40px;
     text-indent: 16px;
     font-size: 14px;
     line-height: 20px;
  `}
`
const InputDefault = styled.input`
  border-radius: 10px;
  width: 100%;
  height: 56px;
  border: 1px solid ${COLOR.blueGray2};
  text-indent: 20px;
  font-size: 18px;

  &::placeholder {
    font-family: NotoSansRegular, sans-serif;
    color: ${COLOR.blueGray3};
  }

  ${customMedia.lessThan('tablet')`
     height: 40px;
     text-indent: 16px;
     font-size: 14px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
     width :100%;
     line-height: 40px;
  `}
  ${customMedia.lessThan('mobile')`
     text-indent: 16px; 
  `}
  
`

const InputFormTitle = styled.p<{ display: string }>`
  display: ${(props) => props.display === "true" ? "flex" : "none"};
  font-family: NotoSansBold, sans-serif;
  font-size: 18px;
  line-height: 26px;
  margin: 0 0 12px 0;
  ${customMedia.lessThan('tablet')`
    font-size: 16px;
    line-height: 23px;
  `}
`

export {
  InputFormWrap,
  InputFormTitle,
  InputDefatultWrap,
  InputDefault,
  InputTelNum,
  InputTelNumWrap,
  InputCertWrap,
  InputCert
}
